// Файл StatePersistor.js

/**
 * Модуль обслуживает сценарий `StatePersistor` в разделе `utils`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { useEffect } from 'react';

import { storage } from './storage';



const TabStatePersistor = ({ 
    tabId, tabsData, activeTab 
}) => {
    useEffect(() => {
        if (
            tabId
            && tabsData?.length > 0

        ) {
            storage.save_state(`tab_${tabId}`, {
                tabsData: tabsData.map((tab) => ({
                    title: tab.title,
                    id: tab.id,
                    meta: tab.meta || {},
                })),
                activeTab,
            });
        }
    }, [tabId, tabsData, activeTab]);

    return null;
};


export default TabStatePersistor;
